import { showDialog } from '../../utils/dialogs';
import type { Translate } from './profileTypes';

const landingBase = (process.env.EXPO_PUBLIC_LANDING_URL || 'https://mentorcoaching.ai').replace(/\/$/, '');
export const PLAN_DETAILS_URL = `${landingBase}/#pricing`;
export const PRIVACY_URL = `${landingBase}/privacy`;

/**
 * Opens `url` in a new tab. If the browser throws, shows `fallbackMessage`
 * in an error dialog and resolves false.
 */
export const openExternalLink = async (t: Translate, url: string, fallbackMessage: string) => {
  try {
    window.open(url, '_blank');
    return true;
  } catch {
    // fall through to alert
  }
  showDialog(t('common.error'), fallbackMessage);
  return false;
};
